<template>
  <div class="testv__post__date__wrapper">
    <span class="testv__post__date">{{ date * 1000 | formatDate }}</span>
    <component :is="icon" class="testv__post__icon"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { formatDate } from '@/utils/index.js'

export default {
  name: 'TestvPostDate',

  props: {
    date: Number,
    category: String
  },

  filters: {
    formatDate
  },

  computed: {
    ...mapState(['pageData']),
    icon () {
      const temp = this.pageData.categories.find(item => item.title === this.category)
      if (temp) return temp.icon
      return 'IconPost'
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/styles/variable.styl"
.testv__post__date__wrapper {
  .testv__post__date {
    writing-mode: vertical-rl;
    text-orientation: mixed;
    font-size: var(--size-TestvPostDateText, 24px);
    font-family: 'DottedSongtiSquare';
  }
  .testv__post__icon {
    width: var(--size-TestvPostDateIcon, 24px);
    height: var(--size-TestvPostDateIcon, 24px);
  }

  @media (min-width: $screen-md) {
    .testv__post__date {
      font-size: var(--size-TestvPostDateText--md, 48px);
    }
    .testv__post__icon {
      width: var(--size-TestvPostDateIcon--md, 48px);
      height: var(--size-TestvPostDateIcon--md, 48px);
    }
  }

  @media (min-width: $screen-default) {
    .testv__post__date {
      font-size: var(--size-TestvPostDateText--max, 112px);
    }
    .testv__post__icon {
      width: var(--size-TestvPostDateIcon--max, 96px);
      height: var(--size-TestvPostDateIcon--max, 96px);
    }
  }
}
</style>
